import { buildFontFamilies } from './buildFontFamilies';
const buildBrandConstants = (brandConstants, brandConstantsOverride) => {
    const customFontFamilies = brandConstantsOverride?.typography
        ? buildFontFamilies(brandConstantsOverride?.typography)
        : {};
    const themeOverrideColors = brandConstantsOverride?.colors || {};
    const filteredThemeColors = Object.keys(themeOverrideColors).reduce((acc, key) => {
        if (themeOverrideColors[key] !== '') {
            acc[key] = themeOverrideColors[key];
        }
        return acc;
    }, {});
    return {
        colors: {
            ...brandConstants.colors,
            ...filteredThemeColors,
        },
        fontFamilies: {
            ...brandConstants.fontFamilies,
            ...customFontFamilies,
        },
        fontSizes: {
            ...brandConstants.fontSizes,
            ...(brandConstantsOverride?.typography?.fontSizes || {}),
        },
        screens: {
            ...brandConstants.screens,
            ...(brandConstantsOverride?.screens || {}),
        },
        defaultSpacing: brandConstantsOverride?.defaultSpacing || brandConstants.defaultSpacing,
    };
};
export default buildBrandConstants;
//# sourceMappingURL=buildBrandConstants.js.map